<!--  -->
<template>
  <div class="">
    <div style="margin: 10px; min-width: 980px">
      <el-table align="center" :header-cell-style="{ background: '#eef1f6', color: '#606266' }" size="mini" highlight-current-row :data="tabelParams.datas.tableData()" style="width: 100%" border @row-click="rowClick">
        <el-table-column v-for="(item, index) in tabelParams.datas.innerData()" :key="index" :width="item.width ? item.width : ''" :type="item.type ? item.type : ''" min-width="130" align="center" prop="code" :label="item.name ? item.name : ''">
          <template slot-scope="scope">
            <!-- 只为序列才显示 -->
            <span v-if="item.type == 'index'" style="margin-left: 10px">{{
              scope.$index + 1
            }}</span>
            <!-- 内容 -->
            <!-- 状态 字段处理 判断是否state，是就渲染 不执行下面代码 -->
            <div v-else-if="item.value == 'state' || item.value == 'status'" style="margin-left: 10px">
              <span>{{ ['','草稿','待审核','审核通过','审核不通过','废弃'][scope.row[item.value]] || scope.row[item.value] }}</span>
            </div>
            <!-- 默认展示 -->
            <span v-else style="margin-left: 10px">{{
              (scope.row[item.value] == null ? '-': false) ||
              (scope.row[item.value] ? scope.row[item.value] : "-")
            }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="!tabelParams.hideOperate" :width="tabelParams.operateWidth ? tabelParams.operateWidth : '120px'" fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <slot :row="scope.row"></slot>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block" v-if="!requestParams.hidePage">
      <!-- 分页 -->
      <el-pagination style="text-align: right" @size-change="tabelParams.event.sizeChange" @current-change="tabelParams.event.currentChange" :current-page="requestParams.curPage" :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next" :total="requestParams.total"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    innerData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    requestParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    tabelParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  //  @row-click="tabelParams.call(tabelParams.tableEvent.rowClick)
  //             ? tabelParams.tableEvent.rowClick
  //             : null"
  /*       // 主表循环参数
      innerData: [
        // 需要序号就添加 type
        { name: "序号", value: "", type: "index", width: "60" },
        { name: "产品代码", value: "code" },
        { name: "状态", value: "state" }, //需要特殊处理
        //  <template slot-scope="scope">
        //     <span v-if="scope.row.state == 1">草稿</span>
        //     <span v-if="scope.row.state == 2">发布</span>
        //     <span v-if="scope.row.state == 3">作废</span>
        //   </template>
        { name: "录入人", value: "inputer" },
      ],
      tabelParams: {
        tabelStyle: {
          margin: "10px",
          "min-width": "980px",
        },
        size: "mini",
        datas:{
          tableData:()=>{
            return this.tableData
          },
          innerData:()=>{
            return this.innerData
          }
        },
        event: {
          sizeChange:(val) =>{
            return this.handleSizeChange(val)
          },
          currentChange:(val) =>{
            return this.handleCurrentChange(val)
          }
        },
      },
       // 查询参数
      requestParams: {
        shipLineId: "", //产品代码,Long
        state: "", //状态，1：草稿，2：发布，3：作废,Int,不传对应全部
        pol: "", //起运港，String
        pod: "", //目的港，String
        carrier: "", //船公司，String
        curPage: 1,
        pageSize: 10,
        // total: 0,
      }, */
  components: {},
  data () {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    rowClick (item) {
      if (
        Object.prototype.toString.call(this.tabelParams.tableEvent.rowClick) ===
        "[object Function]"
      ) {
        this.tabelParams.tableEvent.rowClick(item);
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created () { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { },
};
</script>



// WEBPACK FOOTER //
// src/components/QuotationManagement/jack-components/erp-copy/erp-table.vue